import React, { useEffect, useState } from "react";

import { InputLabel, MenuItem, Select, Box, Typography, Paper, Stack, Chip } from "@mui/material";

import { useForm } from "clients/admin/src/desktop/helpers/forms/FormProvider";
import ListItems from "./ListItems";

import "./Settings.scss";

interface ListEditProps {
  list: "positionsWithCategory" | "requestTypesWithCategory";
  listName: string;
}

interface Item {
  id: string;
  name: string;
  category: string;
}

const ListEdit: React.FC<ListEditProps> = (props) => {
  const { list, listName } = props;
  const { setFieldValue, values } = useForm<Record<string, Item[]>>();
  const [chosenCategory, setChosenCategory] = useState<string>("");

  // Get unique categories for the dropdown
  const categories = Array.from(new Set(values[list]?.map(item => item.category) || []));

  return (
    <Stack spacing={3}>
      {/* Items Management */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: "1px solid rgba(0, 0, 0, 0.08)",
          background: "rgba(255, 255, 255, 0.7)",
          p: 3,
          transition: "all 0.3s ease",
          "&:hover": {
            borderColor: "rgba(255, 107, 107, 0.3)",
            boxShadow: "0 8px 25px rgba(255, 107, 107, 0.1)",
          },
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            color: "#374151",
            mb: 2,
            fontSize: "1rem",
          }}
        >
          ניהול {listName}
        </Typography>

        <ListItems
          currentList={values[list] || []}
          setCurrentList={(value) => {
            setFieldValue(list, value);
          }}
          chosenCategory={chosenCategory}
          itemsKind="name"
        />
      </Paper>
    </Stack>
  );
};

export default ListEdit;



